"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var ProductCards_1 = __importDefault(require("../../../common/ProductCards"));
var content_1 = require("../../../ProductsApp/ducks/content");
var styles_1 = __importDefault(require("./styles"));
var path_utils_1 = require("../../path-utils");
var PopularProducts = function () {
    var _a;
    var popularProducts = (0, react_redux_1.useSelector)(content_1.activeItemPopularProducts);
    var content = (0, react_redux_1.useSelector)(content_1.contentSelector);
    var currentItem = (0, react_1.useMemo)(function () {
        popularProducts.forEach(function (product) {
            if (!product.view.includes('assets'))
                product.view = '/assets/' + product.view;
        });
        return content.items.find(function (item) { return item.singular === content.activeItem; });
    }, [content, popularProducts]);
    var path = (0, path_utils_1.getStorePath)(content.department, content.name, (_a = popularProducts[0]) === null || _a === void 0 ? void 0 : _a.path.split('/')[1]);
    return popularProducts[0] ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.default.Title, { id: "popular" }, "\u0421\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0442\u0430\u043A\u0436\u0435"),
        react_1.default.createElement(styles_1.default.DescriptionText, null,
            "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 ",
            currentItem.titlePopular,
            " \u0432 \u043D\u0430\u0448\u0435\u043C \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435"),
        react_1.default.createElement(ProductCards_1.default, { products: popularProducts, isProductsApp: true }),
        react_1.default.createElement(styles_1.default.GotoStore, null,
            react_1.default.createElement("a", { href: path },
                "\u0421\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432\u0441\u0435 ",
                currentItem.titlePopular,
                " \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435")))) : null;
};
exports.default = PopularProducts;
